import React from "react";

import { Route } from "react-router-dom";

import { CASTINGS_ROUTE } from "./routes";
import CastingList from "../casting/CastingList";
import CastingPage from "../casting/CastingPage";

import type { JSX } from "react";

function CastingRoutes(): JSX.Element {
  return (
    <React.Fragment>
      <Route exact component={CastingList} path={CASTINGS_ROUTE} />
      <Route component={CastingPage} path={`${CASTINGS_ROUTE}/:id`} />
    </React.Fragment>
  );
}
export default CastingRoutes;
